import { useLanguage } from '../i18n/LanguageContext'

const Loader = () => {
  const { t } = useLanguage()

  return (
    <div className="container__loader">
      <div className="loader_scene">
        {/* Garage structure */}
        <div className="loader_garage">
          <div className="loader_garage_roof"></div>
          <div className="loader_garage_wall loader_garage_wall--left"></div>
          <div className="loader_garage_wall loader_garage_wall--right"></div>
          <div className="loader_garage_floor"></div>
          <div className="loader_garage_sign">P</div>
        </div>

        {/* Barrier */}
        <div className="loader_barrier">
          <div className="loader_barrier_post"></div>
          <div className="loader_barrier_arm"></div>
        </div>

        {/* Car */}
        <div className="loader_car">
          <div className="loader_car_body">
            <div className="loader_car_roof"></div>
            <div className="loader_car_window loader_car_window--front"></div>
            <div className="loader_car_window loader_car_window--back"></div>
          </div>
          <div className="loader_car_wheel loader_car_wheel--front"></div>
          <div className="loader_car_wheel loader_car_wheel--back"></div>
          <div className="loader_car_headlight"></div>
        </div>


      </div>
      <p className="loader_text">{t('loading') || 'Laden...'}</p>
    </div>
  )
}

export default Loader
